/** Why OpenMetadata has no valid registration for a table Snowflake has. */
export const OMTableStatus = {
  NOT_REGISTERED: "not_registered",
  SOFT_DELETED: "soft_deleted",
  CASE_MISMATCH: "case_mismatch",
} as const;
export type OMTableStatus = (typeof OMTableStatus)[keyof typeof OMTableStatus];

export interface TableDiffItem {
  fqn: string;
  table_name: string;
}

export interface MissingFromOMItem extends TableDiffItem {
  /** Absent when Snowflake reports no last-altered timestamp (the API drops nulls). */
  snowflake_last_altered?: string;
  om_status: OMTableStatus;
}

export interface StaleInOMItem extends TableDiffItem {
  snowflake_last_ddl: string;
  om_updated_at: string;
  /** Server-computed lag, already humanized (e.g. "3d 4h"). */
  stale_by: string;
}

export interface OrphanedInOMItem extends TableDiffItem {
  om_updated_at: string;
}

export interface TableDiffResponse {
  found_in_snowflake: number;
  found_in_openmetadata: number;
  missing_from_om_count: number;
  orphaned_in_om_count: number;
  stale_in_om_count: number;
  missing_from_om: MissingFromOMItem[];
  orphaned_in_om: OrphanedInOMItem[];
  stale_in_om: StaleInOMItem[];
  /** Table names only, and only when the request sets include_in_sync=true. */
  in_sync?: string[];
  checked_at: string;
}
